import React from 'react';
import styles from './bottom.module.css'
import basestyles from '../../styles/basestyles.module.css';
import {HashLink as Link} from "react-router-hash-link"
function Bottom() {
    return (
   <div id="contacts" className={styles.background}>
      <div className={basestyles.maxWidth}>
      <img src="logo.svg" alt="logo"/>
      <div className={styles.line}></div>
      <div className={styles.bottomSection}>
        <div className={styles.useflex}>
          <ul className={styles.first}>
            <Link smooth to="#home">
            <li >Home</li>
            </Link>
            <Link smooth to="#ourstory">
            <li >About Us</li>
            </Link>
            <Link smooth to="#whyus">
            <li >Why Us</li>
            </Link>
          </ul>
          <ul className={styles.second}>
          <Link smooth to="#ourstory">
           <li>Our Story</li>
          </Link>
          <Link smooth to="#ourteam">
      <li>Our Team</li>
      </Link>
      <Link smooth to="#faq">
      <li>FAQ</li>
      </Link>
      </ul>
        </div>
          <div className={styles.contacts}>
            <h2>Contact Us</h2>
            <div className={styles.phone}>
            <i class="fas fa-phone-alt"></i>
              <a href="tel:‎+91 89510 92635"> +91 89510 92635 |</a>
              <a href="tel:+91 89510 92604"> +91 89510 92604</a>
            </div>
        
            <ul className={styles.icons}>
              <li className={styles.insta}>
                <a href="https://www.instagram.com/adaya.io/" >
                  <i class="fab fa-instagram"></i>
                </a >
              </li>
                      <li className={styles.whatsapp}>
                      <a href="tel:+918951092635">
                        <i class='fab fa-whatsapp-square'></i>
                        </a>
                </li>
                
                      <li className={styles.facebook}>
                        <a href="mailto:adaya.agro@gmail.com">
                        <i class="fas fa-envelope"></i>           
                          </a>
                        </li>
                        <li className={styles.linkedin}> 
                    <a href="https://www.instagram.com/adaya.io/">
                   <i class='fab fa-linkedin'></i>
                  </a>
                </li>   
            </ul>
        </div>
      </div>
      </div>
   </div>
    )
    }
  
  export default Bottom;

